export enum FinancialChoice {
  IamReady,
  InviteFinancialUser,
}
